/* eslint-disable */
import * as Types from '../../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ShareStoryToGhMutationVariables = Types.Exact<{
  storyId: Types.Scalars['String'];
  comment: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type ShareStoryToGhMutation = { __typename: 'Mutation', makeStoryGlobal: { __typename: 'Feed', id: string, review_status: Types.ReviewStatus | null, global_status: Types.GlobalStatus | null } | null };


export const ShareStoryToGhDocument = gql`
    mutation shareStoryToGH($storyId: String!, $comment: String) {
  makeStoryGlobal(id: $storyId, text: $comment) {
    id
    review_status
    global_status
  }
}
    `;
export type ShareStoryToGhMutationFn = Apollo.MutationFunction<ShareStoryToGhMutation, ShareStoryToGhMutationVariables>;

/**
 * __useShareStoryToGhMutation__
 *
 * To run a mutation, you first call `useShareStoryToGhMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareStoryToGhMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareStoryToGhMutation, { data, loading, error }] = useShareStoryToGhMutation({
 *   variables: {
 *      storyId: // value for 'storyId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useShareStoryToGhMutation(baseOptions?: Apollo.MutationHookOptions<ShareStoryToGhMutation, ShareStoryToGhMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareStoryToGhMutation, ShareStoryToGhMutationVariables>(ShareStoryToGhDocument, options);
      }
export type ShareStoryToGhMutationHookResult = ReturnType<typeof useShareStoryToGhMutation>;
export type ShareStoryToGhMutationOptions = Apollo.BaseMutationOptions<ShareStoryToGhMutation, ShareStoryToGhMutationVariables>;